import { FC, ReactNode } from "react";
import { Text } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const CopyContainer: FC<Props> = ({ children }) => {
  return (
    <Text color="th.gray4" fontWeight="light" variant="th-body3">
      {children}
    </Text>
  );
};
